/* src/app/components/footer/footer.component.css */
footer {
  width: 100%;
  font-size: 0.8em;
  color: #ccc;
  background-color: #333;
  text-align: center;
  padding: 8px 0px;
  margin-top: auto;
}
footer .title {
  margin-right: 0.75em;
}
footer a,
footer a:hover,
footer a:active,
footer a:focus,
footer a:visited {
  color: #ccc;
  text-decoration: none;
}
.footerLinks {
  list-style: none;
}
.footerLinks li {
  display: inline-block;
  padding: 0px 3px;
}
.footerLinks li a,
.footerLinks li span {
  padding: 0 5px 0 0;
  border-right: solid 1px #bcbec0;
}
@media screen and (max-width: 1200px) {
  footer .pull-left,
  footer .pull-right {
    float: none !important;
  }
  footer span {
    display: block;
  }
  .btn-add-to-watchlist:active,
  .btn-add-to-watchlist:hover,
  .btn-remove-from-watchlist:active,
  .btn-remove-from-watchlist:hover,
  .btn-fixed-watchlist:active,
  .btn-fixed-watchlist:hover {
    box-shadow: none;
  }
  .btn-fixed-watchlist .pull-right {
    float: right !important;
  }
}
/*# sourceMappingURL=footer.component.css.map */
